<template>
  <form class="py-12" v-on:submit.prevent="prevent">
    <v-slide-x-transition>
      <v-card
        class="mx-auto my-3"
        :loading="loading"
        max-width="768"
        v-if="step == 1"
      >
        <v-card-title>
          {{ $t("register.steps.accession.title") }}
        </v-card-title>
        <v-card-text>
          <v-switch
            v-model="isLegal"
            :label="
              isLegal
                ? $t('register.steps.accession.form.yes')
                : $t('register.steps.accession.form.no')
            "
          ></v-switch>
          <div v-if="!isLegal">
            <v-alert type="warning" outlined>
              <span class="text-subtitle">{{
                $t("register.steps.accession.indicate")
              }}</span>
            </v-alert>
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="form.name"
                  :error-messages="nameErrors"
                  :label="$t('register.steps.user.form.name.label')"
                  required
                  @input="v$.form.name.$touch()"
                  @blur="v$.form.name.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="form.personalDocument"
                  :error-messages="personalDocumentErrors"
                  v-mask="documentMask"
                  :label="assets.countries[this.country].personalDocument"
                  required
                  @input="v$.form.personalDocument.$touch()"
                  @blur="v$.form.personalDocument.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="form.email"
                  :error-messages="emailErrors"
                  :label="$t('register.steps.user.form.email.label')"
                  required
                  @input="v$.form.email.$touch()"
                  @blur="v$.form.email.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions class="d-flex justify-end py-3">
          <div class="d-flex justify-end align-center py-2" style="width: 100%">
            <v-btn
              class="mr-2 white--text"
              color="green"
              elevation="0"
              type="button"
              :loading="confirming"
              :disabled="v$.form.$invalid && !isLegal"
              @click="confirm()"
            >
              {{ $t("register.steps.buttons.next") }}
              <v-icon class="ml-6">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <v-card
        class="mx-auto my-3"
        :loading="loading"
        max-width="768"
        v-if="step == 0"
      >
        <v-card-text>
          <v-row>     
      <v-col cols="6">
            <v-card
              class="my-2"
              elevation="0"
              outlined
              v-for="plan in allPlans"
              :key="plan._id"
              :class="
                plan._id == selectedPlan?._id ? 'primary white--text' : ''
              "
              @click="selectPlan(plan)"
            >
              <div class="d-flex align-baseline">
                <v-card-title class="">{{ plan.name }}</v-card-title>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card elevation="0"  class="subscription-card">
              <div class="d-flex align-baseline justify-space-between">
                <div class="d-flex flex-column font-weight-bold">
                    <div class="d-flex align-center">
                      <v-btn-toggle
                    class="mx-0"
                    color="primary"
                    dense
                    v-model="periodSwitch"
                  >
                    <v-btn height="40">{{ `1 ${$t("common.year")}` }}</v-btn>
                    <v-btn height="40">{{ `2 ${$t("common.years")}` }}</v-btn>
                    <v-btn height="40">{{ `3 ${$t("common.years")}` }}</v-btn>
                  </v-btn-toggle>
                    <v-btn
                      elevation="0"
                      :loading="loading"
                      @click="signaturePlan(false)"
                      target="_blank"
                      color="success ml-2"
                    >
                      {{
                        $t(
                          "account.whitelabel.resource.resourceDialog.activatePlan"
                        )
                      }}
                    </v-btn>     
                  </div>
                  <div class="d-flex align-baseline ">
                    <v-card-subtitle class="mb-4 pa-0 pt-3">
                    <span class="d-block title font-weight-semi-bold">{{
                      $n(yearPriceDialog, "currency")
                    }}</span
                    >{{
                      $t("account.whitelabel.resource.resourceDialog.perYear")
                    }}
                  </v-card-subtitle>
                    <v-card-actions>
                        <v-btn
                        @click="signaturePlan(true)"
                          :loading="loading"
                          text
                          target="_blank"
                          color=""
                          elevation="0"
                          ><v-card-text 
                            style="padding: 0px"
                            class="green--text py-n2"
                            >Testar 15 dias antes de ativar
                            <v-icon color="green" small
                              >mdi-arrow-right</v-icon
                            ></v-card-text
                          ></v-btn>                      </v-card-actions>
                  </div>
                 
                </div>
                <!-- botoes de sign -->
              </div>
              <v-card-subtitle class="mb-4" style="padding: 0px">
                <div class="d-flex flex-column">
                  <span
                    v-for="advantage in selectedPlan?.advantagesText"
                    :key="advantage"
                    class=""
                  >
                    <v-icon class="mr-2">mdi-check</v-icon>{{ advantage }}</span
                  >
                </div>
              </v-card-subtitle>
              <v-divider class="my-3"></v-divider>
              <div class="d-flex align-baseline justify-space-between mb-4">
                <div class="d-flex flex-column font-weight-bold">
                  <div class="d-flex flex-column"></div>
                  <v-card-subtitle class="subtitle pa-0">
                    <span class="d-block title font-weight-semi-bold">{{
                      ` ${selectedPlan?.commission} % `
                    }}</span
                    >{{
                      $t(
                        "account.whitelabel.resource.resourceDialog.transactCommision"
                      )
                    }}
                  </v-card-subtitle>
                </div>
              </div>
              <v-card-subtitle class="mb-8" style="padding: 0px">
                <div class="d-flex flex-column">
                  <span 
                    v-for="resource in selectedPlan?.resourcesText"
                    :key="resource"
                    class=""
                  >
                    <v-icon class="mr-2">mdi-check</v-icon>{{ resource }}</span
                  >
                </div>
              </v-card-subtitle>
              <v-card color="#eeeeee" elevation="0" class="">
            <v-card-text>
              <span class="font-weight-bold"> {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.title"
                    )
                  }}</span>
              <div class="d-flex align-end mb-2">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
                  <strong class="green--text">{{
                    `${selectedPlan?.resources?.discountStore} % ${this.$t(
                      "account.whitelabel.resource.resourceDialog.discount"
                    )} `
                  }}</strong>
                  {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.tmtStore"
                    )
                  }}
                </span>
                <v-img
                  max-width="25"
                  class="ml-2"
                  width="25"
                  src="https://store.themediatrade.com/img/tmstorelogo.2b74392e.svg"
                ></v-img>
              </div>
              <div class="d-flex align-end mb-4">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
              {{ $t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    ) }}
                </span>
                <v-img
                  class="ml-2 "
                  max-width="110"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/tunad_logo.svg"
                ></v-img>
              </div>
              <div class="d-flex align-center ">
                <v-icon class="mr-2">mdi-check</v-icon>
            <span>
              {{$t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    )}}
                </span>
                <v-img
                  class="ml-2"
                  max-width="150"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/kantaribopemedia_logo.svg"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
              <v-card-text> </v-card-text>
            </v-card>
          </v-col>
        </v-row>
          <!-- <v-card class="mx-auto" elevation="0">
            <v-card-title class="font-weight-bold"
              >Escolha seu Plano <v-spacer></v-spacer
            ></v-card-title>
            <v-row>
              <v-col cols="4">
                <v-card
                  class="my-2"
                  elevation="0"
                  outlined
                  :color="selectedPlan.name == plan.name ? 'primary' : '' "
                  :dark="selectedPlan.name == plan.name"
                  v-for="plan in allPlans"
                  :key="plan._id"
                  @click="selectPlan(plan)"
                >
                  <div class="d-flex align-baseline">
                    <v-card-title>{{ plan.name }}</v-card-title>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card 
                  elevation="0"
                  class="subscription-card"
                >
                  <div class="d-flex align-baseline justify-space-between">
                    <div class="d-flex flex-column font-weight-bold">
                      <v-card-title class="headline pt-0 pl-0 font-weight-bold">{{
                        selectedPlan.name
                      }}</v-card-title>
    
                      <v-card-subtitle class="pl-0 pt-0">
                        <span class="d-block title font-weight-semi-bold">{{
                          $n(selectedPlan.annuity, "currency")
                        }}</span
                        >Anuidade
                      </v-card-subtitle>
                    </div>
           
                    <div class="d-flex flex-column">
                      <v-card-actions class="pl-6">
                        <v-btn
                          :loading="loading"
                          @click="signaturePlan(false)"
                          target="_blank"
                          color="success"
                          elevation="0"
                          >Ativar agora</v-btn
                        >
                        <v-snackbar top right color="green" v-model="snackbar">
                          {{ text }}

                          <template v-slot:action="{ attrs }">
                            <v-btn
                              color="pink"
                              icon
                              v-bind="attrs" 
                              @click="snackbar = false"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-snackbar>
                      </v-card-actions>
                      <v-card-actions>
                        <v-btn
                        @click="signaturePlan(true)"
                          :loading="loading"
                          text
                          target="_blank"
                          color=""
                          elevation="0"
                          ><v-card-text 
                            style="padding: 0px"
                            class="green--text py-n2"
                            >Testar 15 dias antes de ativar
                            <v-icon color="green" small
                              >mdi-arrow-right</v-icon
                            ></v-card-text
                          ></v-btn>                      </v-card-actions>
                    </div>
                  </div>
                  <v-card-subtitle style="padding: 0px">
                    <div class="d-flex flex-column">
                      <span class="d-flex pb-2 align-start">
                        <v-icon class="mr-1" color="grey darken-2">mdi-check</v-icon>
                        <span>
                          Plataforma
                          completa com servidor do Google e Check-out
                          Pagarme.</span>

                        </span>
                      <span class="d-flex align-start pb-2 text-sub">
                        <v-icon class="mr-1" color="grey darken-2">mdi-check</v-icon>
                        <span>Manutenção e
                        suporte de sistemas, segurança de dados e
                        transações.</span></span>
                    </div>
                  </v-card-subtitle>
                  <v-divider class="my-2"></v-divider>
                  <div class="d-flex align-baseline justify-space-between">
                    <div class="d-flex flex-column font-weight-bold">
                      <div class="d-flex flex-column"></div>
                      <v-card-subtitle class="subtitle pt-0 pl-0">
                        <span class="d-block title font-weight-semi-bold">{{
                          ` ${selectedPlan.resources.variableTMT} % `
                        }}</span
                        >Comissão The Media Trade
                      </v-card-subtitle>
                    </div>
                  </div>
                  <v-card-subtitle class="mb-2 align-start pt-0 pl-0">
                    <div class="d-flex flex-column">
                      <span class="d-flex pb-3">
                        <v-icon class="mr-1" color="grey darken-2">mdi-check</v-icon>Geração de
                        tráfego e qualificação de leads.</span
                      >
                      <span class="d-flex pb-2 align-start">
                        <v-icon class="mr-1" color="grey darken-2">mdi-check</v-icon
                        >Atendimento,negociação,vendas e OPEC</span
                      >
                    </div>
                  </v-card-subtitle>
                  <v-card color="#e7ebf5" elevation="0" class="">
                    <v-card-text>
                      <div class="d-flex align-center">
                        <v-img
                          class="mr-2"
                          width="30"
                          src="https://store.themediatrade.com/img/tmstorelogo.2b74392e.svg"
                        ></v-img>
                        <span class="mb-2">
                          <strong class="green--text">{{
                            `${selectedPlan.resources.discountStore} % de desconto`
                          }}</strong>
                          em inteligência de mídia e demais serviços da TMT
                          STORE.
                        </span>
                      </div>
                      <div class="d-flex align-center justify-space-around mt-2">
                        <v-img
                          class="mr-2"
                          max-width="80"
                          src="https://tmt-s3-v2.s3.amazonaws.com/public/tunad_logo.svg"
                        ></v-img>

                        <v-img
                          class="mr-2"
                          max-width="160"
                          src="https://tmt-s3-v2.s3.amazonaws.com/public/kantaribopemedia_logo.svg"
                        ></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-card> -->
        </v-card-text>
        <v-card-actions class="d-flex justify-end py-3">
          <div class="d-flex justify-end align-center py-2" style="width: 100%">
            <!-- <v-btn
                class="mr-2 white--text"
                color="green"
                elevation="0"
                type="button"
                :loading="confirming"
                :disabled="!this.selectedPlan || this.signedPlan == false"
                @click="confirm()"
              >
               Ativar Plno
                <v-icon class="ml-6">mdi-arrow-right</v-icon>
              </v-btn> -->
          </div>
        </v-card-actions>
      </v-card>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <v-card
        class="mx-auto my-3"
        :loading="loading"
        max-width="768"
        v-if="step == 2"
      >
        <v-card-title>
          {{ $t("register.steps.accession.great") }}
        </v-card-title>

        <v-card-text v-if="step == 2">
          {{ $t("register.steps.accession.form.aggree") }}

          <iframe
            width="100%"
            height="400px"
            class="mt-6"
            style="border: 2px solid #f0f0f0; flex: 0 0 100%"
            :src="accession.url"
          ></iframe>
          <v-btn :href="accession.url" target="_blank" outlined color="primary"
            ><v-icon class="mr-3">mdi-download</v-icon>
            {{ $t("register.steps.accession.download") }}</v-btn
          >
        </v-card-text>
        <v-card-actions
          class="d-flex justify-space-between py-3"
          v-if="step == 2"
        >
          <v-radio-group v-model="aggrement">
            <v-radio
              value="1"
              :label="$t('register.steps.accession.form.aggrement')"
            ></v-radio>
            <v-radio
              value="skip"
              class="py-0 my-0"
              :label="$t('register.steps.accession.form.afterAggrement')"
            ></v-radio>
          </v-radio-group>
          <v-btn
            class="mr-2 white--text"
            color="green"
            elevation="0"
            type="button"
            :loading="processing"
            :disabled="!aggrement"
            @click="submit()"
          >
            {{ $t("register.steps.accession.next") }}
            <v-icon class="ml-6">mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-slide-x-transition>
  </form>
</template>
<script>
import {mapActions} from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    assets: {
      type: Object,
    },
    hash: {
      type: String,
    },
    country: {
      type: Number,
    },
  },
  data: () => ({
    period: 12,
    periodSwitch:0,
    signedPlan: false,
    snackbar: false,
    text: "Plano assinado com sucesso",
    selectedPlan: null,
    allPlans: [],
    step: 0,
    isLegal: true,
    aggrement: false,
    afterAggrement: false,
    processing: false,
    confirming: false,
    loading: false,
    accession: {},
    form: {
      name: "",
      email: "",
      personalDocument: "",
    },
    errors: {
      document: [],
      email: [],
    },
  }),

  validations() {
    return {
      form: {
        name: { required, minLength: minLength(3), maxLength: maxLength(30) },
        email: { required, email },

        personalDocument: {
          required,
          minLength: minLength(
            this.assets.countries[this.country].personalDocumentMask.length
          ),
        },
      },
    };
  },
  mounted() {
    const doc =
      this.$route.query.step == 3 && this.$route.query.doc
        ? this.$route.query.doc
        : "";
    const term =
      this.$route.query.step == 3 && this.$route.query.term
        ? this.$route.query.term
        : "";
    if (doc && term) {
      this.accession = {
        url: doc,
        termId: term,
      };
      this.step = 2;
    }
    this.getAllPlans();
 
  },

  computed: {



    yearPriceDialog() {
      return (this.selectedPlan?.price / this.selectedPlan?.monthPeriod) * 12;
    },
    
    documentMask() {
      const result = this.assets.countries[this.country].personalDocumentMask;
      return result;
    },
    nameErrors() {
      const errors = [];
      if (!this.v$.form.name.$dirty) return errors;
      this.v$.form.name.minLength.$invalid &&
        errors.push(
          this.$t("register.steps.user.form.name.errors.minLength", {
            count: 3,   
          })
        );
      this.v$.form.name.maxLength.$invalid &&
        errors.push(
          this.$t("register.steps.user.form.name.errors.maxLength", {
            count: 30,
          })
        );
      this.v$.form.name.required.$invalid &&
        errors.push(this.$t("register.steps.user.form.name.errors.required"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.v$.form.email.$dirty) return errors;
      this.v$.form.email.email.$invalid &&
        errors.push(this.$t("register.steps.user.form.email.errors.email"));
      this.v$.form.email.required.$invalid &&
        errors.push(this.$t("register.steps.user.form.email.errors.required"));
      this.errors.email.forEach((error) => {
        errors.push(this.$t(error));
      });
      return errors;
    },
    personalDocumentErrors() {
      const errors = [];
      if (!this.v$.form.personalDocument.$dirty) return errors;
      this.errors.document.forEach((error) => {
        errors.push(
          this.$t(error, {
            doc: this.assets.countries[this.country].personalDocument,
          })
        );
      });
      this.v$.form.personalDocument.required.$invalid &&
        errors.push(
          this.$t("register.steps.user.form.document.errors.required", {
            doc: this.assets.countries[this.country].personalDocument,
          })
        );
      this.v$.form.personalDocument.minLength.$invalid &&
        errors.push(
          this.$t("register.steps.user.form.document.errors.minLength", {
            doc: this.assets.countries[this.country].personalDocument,
            count:
              this.assets.countries[this.country].personalDocumentMask.length,
          })
        );
      return errors;
    },
  },
  watch: {

    periodSwitch(val){
      this.period = (val + 1) * 12
      this.getAllPlans()
    },
    // country:{
    //     immediate: true,
    //     handler(val){
    //         this.$emit('change-country', val)
    //         this.showPhone = false
    //         console.log('reseting phone...')
    //         this.form.phone = ""
    //     }
    // }
    "form.personalDocument"() {
      this.errors.document = [];
    },
    "form.email"() {
      this.errors.email = [];
    },
  },
  methods: {

    ...mapActions("snackbar", ["showSnack"]),

    getCountryCod(id){
      switch (id) {
        case 0:
          return 'BRA'

        case 1:
          return  'CHI'
          
          case 2: 
          return 'COL'
          
          case 3: 'MEX'
          return 
          
          case 4:  'PER'
          return 
          
          default:
          return "BRA";
      }
    },

   async signaturePlan(trial) {
      const form = {
        planId: this.selectedPlan._id,
        hash: this.hash,
        trial:trial
      }; 
      this.loading = true;
      console.log("form", form);
      const url = `whitelabel/signature`;
     await this.$axios.post(url, form)
        .then((response) => {
          console.log("Signature", response);
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        }).then(()=>{
          this.loading = false;
          this.snackbar = true;
          this.signedPlan = true;
          this.step = 1;
          this.showSnack({
              text: this.$t("account.whitelabel.resource.snackMessages.savedPlan"),
              color: "success",
              timeout: 4000,
              icon: "mdi-check",
            });
        });
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
    },
    getAllPlans() {
      this.loadingPlans = true
     const locale =  this.getCountryCod(this.country)
      const url = `whitelabel/plans?pp=10&pg=1&locale=${'BRA'}&status=1&period=${this.period}`;
      this.$axios
        .get(url)
        .then((response) => {
          console.log('resonse', response.data.data)
          this.allPlans = response.data.data.result.sort((p1, p2) => (p1.name > p2.name) ? 1 : (p1.name < p2.name) ? -1 : 0);
           this.selectedPlan = this.allPlans.length ? this.allPlans[0] : null
          this.loadingPlans = false
        })
        .catch((error) => {
          console.log(error);
          this.loadingPlans = false
        });
    },
    prevent(event) {
      event.stopPropagation();
    },
    confirm() {
      this.confirming = true;
      this.v$.$touch();
      if (!this.v$.$invalid || this.isLegal) {
        if (!this.isLegal) {
          const Form = {
            document: this.form.personalDocument,
            email: this.form.email,
            name: this.form.name,
            documentType: this.assets.countries[this.country].personalDocument,
          };
          this.$axios
            .post(
              `portal/register/signupLegal/?hash=${this.hash}`,
              Form
            )
            .then(
              () => {
                this.$axios
                  .post(
                    `portal/register/confirm?hash=${this.hash}`,
                    {}
                  )
                  .then(
                    (response) => {
                      console.log("confirmed", response);
                      this.$emit("set-hash", {
                        hash: this.hash,
                        interaction: "publisher.done",
                      });
                      this.processing = false;
                    },
                    (err) => {
                      const errors = JSON.parse(JSON.stringify(err));
                      alert(`Error: ${errors}`);
                      this.processing = false;
                    }
                  );
              },
              (err) => {
                const error = err.response.data.errors;
                if (error[0][0] == "errors.document.invalid") {
                  this.errors.document.push(
                    "register.steps.user.form.document.errors.invalid"
                  );
                }
                if (error[0].hasOwnProperty("document")) {
                  this.errors.document.push(
                    "register.steps.user.form.document.errors.unavailable"
                  );
                }
                if (error[0].hasOwnProperty("email")) {
                  this.errors.email.push(
                    "register.steps.user.form.email.errors.unavailable"
                  );
                }
                if (error.length && error[0].hasOwnProperty("timeout")) {
                  this.$emit("set-generic-error", "register.token.expired");
                }
                this.processing = false;
              }
            );
        } else {
          const Form = {};
          this.$axios
            .post(`portal/register/done?hash=${this.hash}`, Form)
            .then(
              (response) => {
                this.accession = response.data.data.accession;
                // this.$emit('set-hash', {hash: response.data.data.hash, interaction: response.data.data.interaction})
                this.step = 2;
                this.processing = false;
                console.error("step", this.step);
              },
              (err) => {
                const error = err.response.data.errors;
                if (error.length && error[0].hasOwnProperty("timeout")) {
                  this.$emit("set-generic-error", "register.token.expired");
                } else {
                  console.error("An error found", error);
                }
                this.confirming = false;
              }
            );
        }
      } else {
        this.confirming = false;
      }
    },


    submit() {
      this.processing = true;
      this.v$.$touch();
      // if (!this.v$.$invalid) {
      if (this.aggrement == "1") {
        const Form = {
          id: this.accession.termId,
          //     location: this.assets.countries[this.country].code,
          //     contacts: [{type: 2, contact: this.form.phone, text: ""}],
          //     document: this.form.personalDocument,
          //     email: this.form.email,
          //     jobDescription: this.form.role,
          //     name: this.form.name,
          //     documentType: this.assets.countries[this.country].personalDocument,
          //     password: this.form.password,
          //     passwordConfirm: this.form.confirm
        };
        this.$axios
          .post(
            `portal/register/signature?hash=${this.hash}`,
            Form
          )
          .then(
            (res) => {
              console.log("signed", res);
              console.log("confirming...");
              this.$axios
                .post(
                  `portal/register/confirm?hash=${this.hash}`,
                  {}
                )
                .then(
                  (response) => {
                    console.log("confirmed", response);
                    this.$emit("set-hash", {
                      hash: this.hash,
                      interaction: "publisher.done",
                    });
                    this.processing = false;
                  },
                  (err) => {
                    const errors = JSON.parse(JSON.stringify(err));
                    alert(`Erro: ${errors}`);
                    this.processing = false;
                  }
                );
            },
            (err) => {
              const error = err.response.data.errors;
              console.error("error", error);
              if (error[0].hasOwnProperty("termId")) {
                console.error("Error ignored. We advance to next step.");
                this.$emit("set-hash", {
                  hash: this.hash,
                  interaction: "publisher.done",
                });
              }
            }
          );
        // }

        // else{
        //     this.processing = false
        // }
      } else {
        if (this.aggrement == "skip") {
          this.$emit("set-hash", {
            hash: this.hash,
            interaction: "publisher.done",
          });
          this.processing = false;
        }
      }
    },
  },
};
</script>
